import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    tabRoot: {
      minHeight: '4rem',

      '& .MuiTab-root': {
        minWidth: 'min-content',
        minHeight: 'min-content',
        color: palette.secondary.dark,

        '&.Mui-selected': {
          color: palette.primary.dark,
        },
      },
    },

    tabIndicator: {
      backgroundColor: palette.primary.dark,
    },
  }),
)
